module.exports = __webpack_public_path__ + "static/img/zhongkong-lixian.b9c52896.png";